export default __webpack_public_path__ + "static/Wamo_banner-a3812c3decfaaacec561558d7dc5d0ce.jpg";